import { render } from "./skins.vue.js?vue&type=template&id=802ea954!=!../../../vue-loader/dist/index.js??ruleSet[0]!./skins.vue?vue&type=template&id=802ea954"
import script from "./skins.vue.js?vue&type=script&lang=js!=!../../../vue-loader/dist/index.js??ruleSet[0]!./skins.vue?vue&type=script&lang=js"
export * from "./skins.vue.js?vue&type=script&lang=js!=!../../../vue-loader/dist/index.js??ruleSet[0]!./skins.vue?vue&type=script&lang=js"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__